import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import InstructionText from 'components/parking-passes/parking-instructions/instruction-text';

const propTypes = {
  instructions: PropTypes.string,
};

const defaultProps = {
  instructions: '',
};

const ParkingPassPickupInstructions = ({ instructions }) => {
  if (isEmpty(instructions)) { return null; }

  return (
    <InstructionText
      title="Returning to Your Car"
      titleId="parking-pass.returning-to-car"
      content={instructions}
    />
  );
};

ParkingPassPickupInstructions.propTypes = propTypes;
ParkingPassPickupInstructions.defaultProps = defaultProps;
export default ParkingPassPickupInstructions;
